export const OrderDeliveryTurbo = {
  classValidation: (row: any) => {
    if (row.invalid) {
      return 'pending';
    }
    return '';
  },
  show: 'No hay datos que mostrar',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  paginatorAllData: true,
  columns: [
    {
      title: 'N° Despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.dispatchId
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.skuCode
    },
    {
      title: 'Cantidad a entregar',
      name: 'processedAmount',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.processedAmount
    },
    {
      title: 'Fecha de entrega',
      name: 'dispatchDate',
      type: 'string',
      editable: false,
      class: 'center',
      value: (element: any) => element.dispatchDate
    },
  ]
}